import { render, staticRenderFns } from "./print-bon-medical.html?vue&type=template&id=6506d9ed&scoped=true&external"
import script from "./print-bon-medical.js?vue&type=script&lang=js&external"
export * from "./print-bon-medical.js?vue&type=script&lang=js&external"
import style0 from "./print-bon-medical.scss?vue&type=style&index=0&id=6506d9ed&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506d9ed",
  null
  
)

export default component.exports